export const AUTH0_DOMAIN_URL = `https://${process.env.REACT_APP_AUTH0_DOMAIN}`;

export const AUTH0_LOGIN_URL = `https://${process.env.REACT_APP_AUTH0_DOMAIN}/authorize?client_id=${process.env.REACT_APP_AUTH0_CLIENT_ID}&response_type=token`;

export const CLOUDINARY_URL = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_NAME}`;
